const storeState = {
  width: window.innerWidth,
  scrollPosition: 0,
  goDark: false,
};

window.addEventListener('resize', () => {
  storeState.width = window.innerWidth;
});


const mutations = {
  setPosition(state, data) {
    // eslint-disable-next-line
    state.scrollPosition = data;
  },
  goDark(state, data) {
    // eslint-disable-next-line
    state.goDark = data;
  },
};
const actions = {
  goDark({ commit }, data) {
    commit('goDark', data);
  },
  blockScroll({ commit }, payload) {
    const html = document.getElementsByTagName('html')[0];
    const body = document.getElementsByTagName('body')[0];
    if (payload) {
      commit('setPosition', html.scrollTop);
    }
    const position = storeState.scrollPosition;
    const blockBody = () => {
      html.style.cssText = `
        overflow:hidden;
        position:fixed;
        height:100%;`;
      body.style.cssText = `
        overflow:hidden;
        position:fixed;
        top: -${position}px;
        height:calc(100% + ${position}px);`;
    };
    const removeBLock = () => {
      html.style.cssText = '';
      body.style.cssText = '';
      window.scroll(0, position);
      html.style.cssText = 'scroll-behavior: smooth;';
      body.style.cssText = 'scroll-behavior: smooth;';
    };
    if (payload) {
      blockBody();
    } else {
      removeBLock();
    }
  },
};
const getters = {
  width() {
    return storeState.width;
  },
  goDark() {
    return storeState.goDark;
  },
};


export default {
  state: storeState,
  actions,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/system.js